// Interfaces TypeScript

import { AmountType, Discount, Price, Image, AlternativeDay, Hotel } from './Commons'

interface HotelAvailabilityResponse {
  hotels: Hotel[]
  hotelAvailabilities: HotelAvailability[]
  crossSellingProducts: CrossSellingProduct[]
}

interface HotelAvailability {
  hotelCode: string
  roomAvailabilities: RoomAvailability[]
  errorCode: string
}

interface RoomAvailability {
  roomCode: string
  quota: number
  rates: Rate[]
  roomIndex: string | number // la API lo envía como número
  errorCode?: string // '' cuando la habitación está disponible; código de error cuando no lo está
}

interface Rate {
  code: string
  name: string
  isOffer: boolean
  isNoRefundable: boolean
  meals: Meal[]
  alternativeDays: AlternativeDay[]
  additionalInfo: additionalInfo[],
  depositInfo? : DepositInfo
  modificationCost?: number
}

interface CancellationPolicy {
  code: string
  deadLine: string | null
  penalty: penalty
  maxMinutesForFreeCancellation: number
  cancellationPolicyType: CancellationApplicationType
  penaltyNightType: PenaltyNightType
  amount: number
  applyInOfferPrice: boolean
  applyIfInsurance: boolean
  RefundableAsBonus: boolean
}
enum CancellationApplicationType {
  Percent = 0,
  Fix = 1,
  Nights = 2
}
enum DepositType {
  Percent = 0,
  Fixed = 1,
}

interface DepositInfo {
  depositType: DepositType
  amount: number
  beforeDate: string
}


enum PenaltyNightType {
  NoApply = 0,
  Average = 1,
  FirstNight = 2,
  LastNight = 3,
  MostExpensiveNight = 4,
  CheapestNight = 5
}

interface penalty {
  type: PenaltyType
  penaltyTypeText: string
  amount: number
}


interface Meal {
  code: string
  IsOffer: boolean
  PaymentType: PaymentType
  PaymentTypeText: string
  price: price
  rateKey: string
  Discount?: Discount
  cancellationPolicies: CancellationPolicy[]
  priceBreakdown: PriceBreakDown[]
  totalPriceModifier: PriceModifier[] | null
}

interface PriceBreakDown {
  priceDate: Date
  totalPrice: Price
  RoomPrice: Price
  mealPrice: Price
  guaranteedQuota: boolean
  priceModifier: PriceModifier
}

export interface PriceModifier {
  code: string
  currencyIsoCode: string
  amount: number
  amountType: 'fixed' | 'percent'
  isAlreadyApplied: boolean
  priceModifierTypeText: string
}

interface price {
  netPrice: Price
  pvpPrice: Price
  commission?: Price
  priceType: number
  taxIncluded: boolean

  prePayments: any[]

  //TODO: Borrar la siguiente línea, es solo para que no fallen los mocks
  Commissions: any
}

interface Commission {
  PaymentType: PaymentType
  CommissionWithGuarantee: Price
  CommissionWithoutGuarantee: Price
  NetWithGuarantee: Price
  NetWithoutGuarantee: Price
}

interface MixedPayment {
  Amount: number
  AmountType: AmountType
}

interface additionalInfo {
  messageType? : MessageType
  messageCode? : string
  message: string
  alertType: AlertType
}

interface CrossSellingProduct {
  ProductCode: string
  ServicePricingType: string
  RoomCodes: string[]
  hotelCodes: string[]
  Name: string
  ShortDescription: string
  LargeDescription: string
  ImageUrl: Image
  IsOffer: boolean
  Price: Price
  Discount: Discount
}

export enum PenaltyType {
  Percent,
  Fix,
  Nights
}

export enum PaymentType {
  Hotel,
  PrePayCard,
  PrePayTransfer,
  PrePayPayPal,
  Credit
}

export enum AlertType {
  Info,
  Warning,
  Danger
}

export enum MessageType {
  Extra,
  Supplement,
  Differencial
}

export type {
  HotelAvailabilityResponse,
  HotelAvailability,
  RoomAvailability,
  Rate,
  CancellationPolicy,
  penalty,
  Meal,
  price,
  Commission,
  MixedPayment,
  additionalInfo,
  CrossSellingProduct,
  CancellationApplicationType,
  PenaltyNightType,
  DepositInfo
}

export { DepositType }
